import { render, staticRenderFns } from "./PrintStep.vue?vue&type=template&id=71968573&scoped=true&"
import script from "./PrintStep.vue?vue&type=script&lang=js&"
export * from "./PrintStep.vue?vue&type=script&lang=js&"
import style0 from "./PrintStep.vue?vue&type=style&index=0&id=71968573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71968573",
  null
  
)

export default component.exports